import { Injectable } from '@angular/core';
//import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
//import { State } from '@progress/kendo-data-query';
//import { PageState } from '../../../src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ExportService {

    constructor() { }

    fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    fileExtension = '.xlsx';

    /*public exportExcel(jsonData: any[], fileName: string): void {
  
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
      const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      this.saveExcelFile(excelBuffer, fileName);
    }
  
    private saveExcelFile(buffer: any, fileName: string): void {
      const data: Blob = new Blob([buffer], { type: this.fileType });
      //FileSaver.saveAs(data, fileName + this.fileExtension);
    }*/
    /*public pageState: State = {
        skip: PageState.skip,
        take: PageState.take
    };
    FilterData(jsonData: any[], fileName: string, pageState: State): any[] {
        if (pageState.filter && pageState.filter.filters.length > 0) {

            this.pageState.skip = PageState.skip;
            this.pageState.take = this.jsonData.total;
            const temdataExport: any = process(this.menuData, this.pageState);
            const result: ExcelExportData = {
                data: process(temdataExport.data, this.pageState).data
            };
            this.pageState.take = PageState.take;
            this.gridMenus = process(temdataExport.data, this.pageState);

            return result;
        } else {
            const result: ExcelExportData = {
                data: process(this.menuData, {}).data
            };

            return result;
        }
    }*/
    ExportToExcel(jsonData: any[], fileName: string) //, pageState: State) 
    {
        console.log(jsonData);
        //console.log(jsonData1);
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData); //.table_to_sheet(this.TABLE.nativeElement);  
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, fileName + this.fileExtension);
    }
}